// extracted by mini-css-extract-plugin
module.exports = {"right":"HobbiesRightPart_right__1uD4n","interests":"HobbiesRightPart_interests__6UCML","titles":"HobbiesRightPart_titles__38jCc","interest":"HobbiesRightPart_interest__1pK30"};